<template>
  <form v-on:submit.prevent="process" autocomplete="off">
    <div class="space-y-4">
      <h3
        class="text-lg leading-6 font-medium text-gray-900"
        id="modal-headline"
      >
        Confirm Tracking deletion
      </h3>

      <p class="text-gray-700">
        By clicking the Confirm button below the selected Freight Orders will be
        removed from freight and moved to normal print
      </p>

      <p class="text-gray-700">Total Orders: {{ totalOrderCount }}</p>

      <p class="text-sm leading-5 text-red-500 text-center">
        <icon set="solid" name="exclamation" class="w-5 h-5 inline-block" />
        This action cannot be undone
      </p>

      <HttpError :error="error" />

      <div class="sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <Button
            type="submit"
            :disabled="processing"
            class="flex items-center space-x-2"
          >
            <span>Confirm</span>
            <LoadingSpinner v-if="processing" class="text-white" />
          </Button>
        </span>
        <span class="flex w-full rounded-md shadow-sm sm:w-auto">
          <Button
            class="btn btn-white"
            :disabled="processing"
            v-on:click-handler="$emit('onClose', true)"
          >
            Cancel
          </Button>
        </span>
      </div>
    </div>
  </form>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Button from "@/components/elements/Button.vue";
import { ModalBus } from "@/eventBus";

const Orders = ApiFactory.get("orders");

export default {
  name: "FreightRejectConfirm",
  props: {
    orders: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      processing: false,
      error: null,
    };
  },
  components: {
    Button,
  },
  computed: {
    totalOrderCount() {
      return this.orders.length;
    },
  },
  methods: {
    process() {
      this.processing = true;
      this.error = null;
      Orders.rejectOrders(this.orders)
        .then(this.handleSuccess)
        .catch((error) => (this.error = error))
        .finally(() => (this.processing = false));
    },
    handleSuccess() {
      this.$emit("onClose");
      ModalBus.$emit("freight:review:refresh");
    },
  },
};
</script>
